<template>
  <div>
    <v-container>
      <v-row>
        <v-col>
          <v-text-field
            label="Currency Code"
            prepend-icon="mdi-magnify"
            v-model="currencyCode"
            @input="syncFiltered()"
            solo
            clearable
          ></v-text-field>
        </v-col>
      </v-row>
    </v-container>
    <v-container fluid>
      <v-data-table
        :headers="headers"
        :items="currenciesFiltered"
        sort-by="id"
        class="elevation-10"
      >
        <template v-slot:item.actions="{ item }">
          <v-icon
            small
            class="mr-2"
            v-if="isAdminUser"
            @click="editCurrency(item)"
          >
            mdi-pencil
          </v-icon>
        </template>
      </v-data-table>
    </v-container>
  </div>
</template>

<script>
/* eslint-disable */
import { parameters } from "../../parameters";
import { httpClient, authState } from "../../requesters/httpClient";
import { USER_ROLE } from "../../requesters/userConstants";
import router from "../../router";

export default {
  name: "Currencies",
  data() {
    return {
      currencies: [],
      currenciesFiltered: [],
      currencyCode: "",
      headers: [
        {
          text: "ID",
          align: "start",
          sortable: false,
          value: "id",
        },
        { text: "Currency Code", value: "currencyCode" },
        { text: "Display Code", value: "displayCode" },
        { text: "Iso Code", value: "isoCode" },
        { text: "Decimal Number", value: "decimalNumber" },
        { text: "Begin", value: "begin" },
        { text: "End", value: "end" },
        { text: "Actions", value: "actions", sortable: false },
      ],
    };
  },
  computed: {
    isAdminUser() {
      return authState.role === "ROLE_ADMIN";
    }
  },
  async mounted() {
    await httpClient
      .get(`${parameters.posdataRefUrl}/currencies`)
      .then((response) => {
        this.currencies = response.data;
        this.syncFiltered();
      })
      .catch((error) => {
        throw error;
      });
  },
  methods: {

    syncFiltered: function(){
      this.currenciesFiltered = new Array();

      this.currencies.forEach(currency => {
        if (this.isCurrencyFiltered(currency)){
          this.currenciesFiltered.push(currency);
        }
      })
    },

    isCurrencyFiltered: function (currency) {
      return (
        this.currencyCode === null || this.currencyCode === "" || this.currencyCode === currency.currencyCode
      );
    },

    editCurrency: function (currency) {
      router.push({
        path: "editCurrency",
        query: { id: currency.id },
      });
    },
  },
};
</script>





// WEBPACK FOOTER //
// src/components/currencies/Currencies.vue